module.exports = __webpack_public_path__ + "media/img/home/img_sg-9401289daf5cd19bdf1f1fca30caf9bf.png";